import AzureAuthService from "@/services/AzureAuthService";
import axios from "axios";

export const RequestInterceptor = async (req) => {

    // Don't set token on presigned S3 urls — S3 answers 400 if a request carries both
    // the query string signature and an Authorization header. Matched on the signature,
    // not the bucket name, since bucket names differ between accounts/environments.
    const isPresignedS3 = /[?&]X-Amz-Signature=/.test(req.url ?? "");
    if(isPresignedS3){
        return req;
    }

    await AzureAuthService.refreshToken();

    let token = localStorage.getItem("token");
    if (token) {
        req.headers.Authorization = "Token " + token;
        axios.defaults.headers.common["Authorization"] = "Token " + token;
    }
    
    return req;
};

export default RequestInterceptor;
